var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"executions-log page section"},[_c('router-view',{attrs:{"disableProgressIndicator":_vm.disableProgressIndicator}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }